export const PATH_MEASUREMENT = '/';
export const PATH_MEASUREMENT_ADD = 'add';
export const PATH_MEASUREMENT_EDIT = 'edit/:date';
